/*
  Gedeelde slider voor het PVC Vloeren Shop redesign.

  Gebruik:

    <pvcvs-slider class="pvcvs-slider">
      <button data-pvcvs-slider-prev>…</button>
      <div class="pvcvs-slider__track" data-pvcvs-slider-track tabindex="0">…</div>
      <button data-pvcvs-slider-next>…</button>
      <div class="pvcvs-slider__progress" data-pvcvs-slider-progress>
        <span class="pvcvs-slider__bar" data-pvcvs-slider-bar></span>
      </div>
    </pvcvs-slider>

  Alleen het spoor is verplicht; pijlen en voortgangsbalk zijn optioneel.
  De kaartbreedte komt volledig uit de CSS (--pvcvs-slides).
*/

if (!customElements.get('pvcvs-slider')) {
  class PvcvsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-pvcvs-slider-track]');
      if (!this.track) return;

      this.prev = this.querySelector('[data-pvcvs-slider-prev]');
      this.next = this.querySelector('[data-pvcvs-slider-next]');
      this.progress = this.querySelector('[data-pvcvs-slider-progress]');
      this.bar = this.querySelector('[data-pvcvs-slider-bar]');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.update = this.update.bind(this);

      if (this.prev) this.prev.addEventListener('click', () => this.scrollByCard(-1));
      if (this.next) this.next.addEventListener('click', () => this.scrollByCard(1));

      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
      }

      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.update);
      if (this.observer) this.observer.disconnect();
    }

    /* Eén stap is precies één kaart plus de tussenruimte. */
    get step() {
      const card = this.track.firstElementChild;
      if (!card) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    scrollByCard(direction) {
      this.track.scrollBy({
        left: direction * this.step,
        behavior: this.reduceMotion.matches ? 'auto' : 'smooth',
      });
    }

    update() {
      const scrollable = this.track.scrollWidth - this.track.clientWidth;
      const fits = scrollable < 2;

      if (this.prev) {
        this.prev.hidden = fits;
        this.prev.disabled = this.track.scrollLeft <= 1;
      }

      if (this.next) {
        this.next.hidden = fits;
        this.next.disabled = this.track.scrollLeft >= scrollable - 1;
      }

      if (this.progress) this.progress.hidden = fits;

      if (this.bar && !fits) {
        const visible = this.track.clientWidth / this.track.scrollWidth;
        const offset = this.track.scrollLeft / this.track.scrollWidth;
        this.bar.style.width = (visible * 100).toFixed(2) + '%';
        this.bar.style.left = (offset * 100).toFixed(2) + '%';
      }

      /*
        Bij een rij productkaarten horen de pijlen op het midden van de foto te
        staan, niet op het midden van de kaart — die hoogte verschilt per
        breedte, dus die meten we. Rijen zonder foto houden de CSS-standaard.
      */
      const media = this.track.querySelector('.pvcvs-card__media');
      if (media) {
        const height = media.getBoundingClientRect().height;
        if (height) this.style.setProperty('--pvcvs-arrow-top', Math.round(height / 2) + 'px');
      }
    }
  }

  customElements.define('pvcvs-slider', PvcvsSlider);
}
